/*eslint-disable*/
import { makeStyles } from '@material-ui/core/styles';
import { fontWeight } from '@material-ui/system';
import backgroundLogo from '../../assets/background/BackgroundLogin.png';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    bg: {
        backgroundImage: `url(${backgroundLogo})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '100%',
        backgroundPosition: 'top left',
        [theme.breakpoints.down('xs')]: {

        },
        [theme.breakpoints.down('sm')]: {

        },
        [theme.breakpoints.up('sm')]: {

        },
        [theme.breakpoints.down('md')]: {

        },
        [theme.breakpoints.up('md')]: {

        },
    },
    title: {
        fontSize: '1.425rem',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: '29px'
    },
    button: {
        backgroundColor: '#024787'
    },
    textLink: {
        color: '#024787'
    },
    dialogTitle: {
        color: '#001930',
        fontSize: '1.625rem',
        fontWeight: 700
    },
    titleCenter: {
        color: '#001930',
        fontSize: '1.625rem',
        fontWeight: 700,
        textAlign: 'center'
    },
    description: {
        color: '#42526E',
        textAlign: 'center',
        paddingTop: '15px'
    }
}));

export { useStyles };
